import { designTokens } from "@itandi/itandi-bb-ui";
import { Flex } from "@itandi/itandi-bb-ui/Flex";
import { useNotification } from "@itandi/itandi-bb-ui/NotificationBarStore";
import { PresentationChip } from "@itandi/itandi-bb-ui/PresentationChip";
import { StatusChip } from "@itandi/itandi-bb-ui/StatusChip";
import { Table } from "@itandi/itandi-bb-ui/Table";
import { Tbody } from "@itandi/itandi-bb-ui/Tbody";
import { Td } from "@itandi/itandi-bb-ui/Td";
import { TextLink } from "@itandi/itandi-bb-ui/TextLink";
import { Th } from "@itandi/itandi-bb-ui/Th";
import { Thead } from "@itandi/itandi-bb-ui/Thead";
import { Tr } from "@itandi/itandi-bb-ui/Tr";
import { formatDateTime } from "@itandi/tools/vanilla";
import { useDealContext } from "~/context/DealContext";
import { useDealWorkflows } from "~/hooks/deals/useDealWorkflows";
import { DEAL_WORKFLOW_STATUS_CHIP } from "~/models/DealWorkflow";
import { BUILTIN_WORKFLOW_TAG_SYSTEM_KEY } from "~/models/itandi_task/Workflow";
import { itandiTaskWorkflowUrl } from "~/utils/ItandiTaskPath";

export function DealWorkflowTable() {
	const deal = useDealContext();
	const { notify } = useNotification();
	const { data: workflows, isLoading } = useDealWorkflows(deal.id, () => {
		notify({
			content: "ワークフローの取得に失敗しました。",
			variant: "error"
		});
	});

	return (
		<Table>
			<Thead>
				<Tr>
					<Th>ワークフロー名</Th>
					<Th>タグ</Th>
					<Th>状況</Th>
					<Th>現在のステップ</Th>
					<Th>開始日時</Th>
					<Th>申請者</Th>
					<Th width="13rem">コメント</Th>
				</Tr>
			</Thead>
			<Tbody loading={isLoading}>
				{workflows?.map((workflow) => (
					<Tr key={workflow.uuid}>
						<Td>
							<TextLink
								color="link"
								href={itandiTaskWorkflowUrl(workflow.uuid)}
								target="_blank"
								weight="bold"
							>
								{workflow.name}
							</TextLink>
						</Td>
						<Td>
							<Flex gap={designTokens["spacing/xs"]} wrap="wrap">
								{workflow.builtinWorkflowTags.map((tag) =>
									tag.systemKey ===
									BUILTIN_WORKFLOW_TAG_SYSTEM_KEY.NSK ? null : (
										<PresentationChip key={tag.systemKey} variant="blue">
											{tag.label}
										</PresentationChip>
									)
								)}
							</Flex>
						</Td>
						<Td>
							<StatusChip
								variant={DEAL_WORKFLOW_STATUS_CHIP[workflow.status].variant}
							>
								{DEAL_WORKFLOW_STATUS_CHIP[workflow.status].label}
							</StatusChip>
						</Td>
						<Td>{workflow.currentStep?.name}</Td>
						<Td>{formatDateTime(workflow.createdAt)}</Td>
						<Td>{workflow.applicantName}</Td>
						<Td>{workflow.latestTaskComment}</Td>
					</Tr>
				))}
			</Tbody>
		</Table>
	);
}
